import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles/input-manager.module.css';
import TextInput from '@/components/chatbot/Layout/inputs/TextInput';
import InputTypes from '@/constants/InputTypes';
import { getActiveBlock, shouldGoNext } from '@/helpers/Flow';
import DateInput from '@/components/chatbot/Layout/inputs/DateInput';
import SalaryInput from '@/components/chatbot/Layout/inputs/SalaryInput';
import FileInput from '@/components/chatbot/Layout/inputs/FileInput';
import TagInput from '@/components/chatbot/Layout/inputs/TagInput';
import SelectInput from '@/components/chatbot/Layout/inputs/SelectInput';
import MultipleSelectInput from '@/components/chatbot/Layout/inputs/MultipleSelectInput';
import { maxOptions as paginatedMaxOptions } from '@/components/chatbot/Layout/messages/PaginatedOptions';

class InputManager extends Component {
  getInput(activeBlock) {
    if (shouldGoNext(activeBlock) === false && !this.props.isFinished) {
      switch (activeBlock.inputType) {
        case InputTypes.OPTIONS:
          return activeBlock.options?.answers?.length > paginatedMaxOptions ? (
            <SelectInput block={activeBlock} />
          ) : null;
        case InputTypes.MULTIPLE_SELECT_OPTIONS:
          return <MultipleSelectInput block={activeBlock} />
        case InputTypes.TEXT:
          return <TextInput block={activeBlock} />;
        case InputTypes.DATE_PICKER:
          return <DateInput block={activeBlock} />;
        case InputTypes.SALARY_PICKER:
          return <SalaryInput block={activeBlock} />;
        case InputTypes.FILE_UPLOAD:
          return <FileInput block={activeBlock} />;
        case InputTypes.TAG_LIST:
          return <TagInput block={activeBlock} />;
        default:
          return;
      }
    }
  }

  render() {
    const activeBlock = getActiveBlock(this.props.conversation);
    return (
      <div id="parent_node" className={styles.inputWrapper}>
        {this.getInput(activeBlock)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  conversation: state.chatbotFlow.conversation,
  isFinished: state.chatbotFlow.isFinished,
  loading: state.chatbotFlow.loading,
});
export default connect(mapStateToProps)(InputManager);
